/**
 * The password rules (issue #18), mirroring `App\Security\PasswordPolicy` on
 * the API so a surface can say what is wrong before the round trip and get the
 * same answer the API would give.
 *
 * Only the length rules are mirrored. The other half of the policy is a check
 * against ~22,000 known-breached passwords, and that list stays on the API: it
 * is far too large to ship to a browser, and sending a candidate password
 * somewhere to be looked up is the thing the design avoids. So the API has the
 * last word here, and a password that passes these checks can still come back
 * refused — `PASSWORD_RULES_HINT` says so up front rather than letting that
 * arrive as a surprise.
 */

export const PASSWORD_MIN_LENGTH = 10

/** Long passphrases are the point; the cap only exists to bound hashing work. */
export const PASSWORD_MAX_LENGTH = 128

export const PASSWORD_RULES_HINT =
  `At least ${PASSWORD_MIN_LENGTH} characters. Passwords found in public breach lists are refused, ` +
  'so pick something that is yours rather than something familiar.'

/**
 * What is wrong with this password as far as a client can tell, or null.
 */
export function describePasswordProblem(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Use a password of at least ${PASSWORD_MIN_LENGTH} characters.`
  }

  if (password.length > PASSWORD_MAX_LENGTH) {
    return `Use a password of no more than ${PASSWORD_MAX_LENGTH} characters.`
  }

  return null
}
